// extracted by mini-css-extract-plugin
export default {"platform-web":"platform-web__szTuG","platform-mob":"platform-mob__EjXsb"};